import { AddToCartActionOption, CartEvents } from '@wix/wixstores-client-core';
import { EcomPlatformViewerScriptContext } from '../../../viewer-script/types';
import { getLeanGQLCartFromCart } from '../../../services/current-cart-service/getLeanGQLCartFromCart';
import type { BaseActionsParams } from '../../types';
import { BaseActions } from './baseActions';

export class TinyCartActions extends BaseActions {
  private readonly context: EcomPlatformViewerScriptContext;
  constructor({
    siteStore,
    origin,
    context,
  }: BaseActionsParams & { context: EcomPlatformViewerScriptContext }) {
    super({ siteStore, origin });
    this.context = context;
  }

  public async showTinyCart({
    addedProductId,
  }: { addedProductId?: string } = {}): Promise<void> {
    const leanGQLCartModel = await getLeanGQLCartFromCart({
      currentCartService: this.context.currentCartService,
      wixApi: this.context.wixApi!,
      platformServices: this.context.platformServices!,
    });

    if (addedProductId) {
      this.siteStore.pubSubManager.publish(CartEvents.CHANGED, {
        ...leanGQLCartModel,
        extraParams: { origin: 'ShowTinyCart' },
        eventOptions: {
          shouldOpenCart: true,
          addToCartActionOption: AddToCartActionOption.TINY_CART,
          addedProductId,
          originatedInWorker: true,
        },
        reason: 'ShowTinyCart',
      });
    } else {
      this.siteStore.pubSubManager.publish('Tinycart.Show', null);
    }
  }

  public hideTinyCart(): void {
    this.siteStore.pubSubManager.publish('Tinycart.Hide', null);
  }
}
